import clsx from 'clsx';
import { BETTING_CODE, selectTicketMaxLangth } from '@/hooks/query';
import { useTranslations } from 'next-intl';
import { betslipStyle } from '@/features/betslip/betslip.style';

interface NoticeProps {
	code: number;
	msg?: string;
	msgDetails?: Map<string, string>;
	msgResourceKey?: string;
	status?: 'closed' | 'same-match' | 'warning';
}

/**
 * Betslip - 提示訊息
 * @param code error code
 * @param msg error msg
 * @param msgResourceKey error msg resource key
 * @param msgDetails error msg detail (only for parlay min odds)
 * @param status css status
 */
export const Notice = ({ code, msg, msgDetails, msgResourceKey, status }: NoticeProps) => {
	const t = useTranslations('General');

	const statusClassName = status ? ` bet-slip__notice--${status}` : '';
	let content = null;

	if ([0, -99].includes(code)) return null;

	if ([60, 61].includes(code) && msgDetails) {
		const beginMsg = code === 60 ? t('lbl_LessthanMinOddsMsg1') : t('lbl_PrlyMaxPOPoolbyCmboMsg1');
		const endMsg = code === 60 ? t('lbl_LessthanMinOddsMsg2') : t('lbl_PrlyMaxPOPoolbyCmboMsg2');
		content = (
			<>
				{beginMsg}
				{
					msgDetails ? Object.keys(msgDetails).map((ticketIdx, idx) => (
						<span key={idx} className="bet-slip__notice-number">{ticketIdx}</span>
					)) : null
				}
				{endMsg}
			</>
		);
	} else {
		if (code === BETTING_CODE.ExceedLimitSelection) {
			content = t(msgResourceKey, { 0: selectTicketMaxLangth.toString() });
		} else {
			content = msgResourceKey ? t(msgResourceKey) : msg;
		}
	}

	return <div className={clsx('bet-slip__notice', statusClassName, betslipStyle.notice)}>{content}</div>;
}